import {Component, OnDestroy, OnInit} from '@angular/core';

@Component({
  selector: 'cm-datetime-viewer',
  templateUrl: './datetime-viewer.component.html',
  styleUrls: ['./datetime-viewer.component.scss']
})
export class DatetimeViewerComponent implements OnInit, OnDestroy {

  now: number;
  intervalId;

  constructor() { }

  ngOnInit(): void {
    this.intervalId = setInterval(() => this.now = Date.now(), 1000);
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
  }
}
